export default "__VITE_ASSET__BAgJx_P3__"